import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { getWeddings, deleteWedding, normalizeGallery } from "@/lib/cloudApi";
import { toast } from "sonner";
import { Plus, Trash2, Edit3 } from "lucide-react";

export default function AdminWeddings() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const data = await getWeddings(); setItems(Array.isArray(data)?data:[]); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const del = async (slug) => {
    if (!window.confirm(`Delete "${slug}"?`)) return;
    try { await deleteWedding(slug); toast.success("Deleted"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="p-10" data-testid="admin-weddings">
      <div className="flex items-center justify-between">
        <div>
          <div className="eyebrow text-[#C99A45]">Manage</div>
          <h1 className="font-serif-display text-5xl mt-3">Weddings</h1>
        </div>
        <Link to="/admin/weddings/new" className="btn-gold" data-testid="add-wedding">
          <Plus size={14} /> Add Wedding
        </Link>
      </div>
      <div className="gold-divider my-6"></div>

      {loading ? <div className="text-[#F7F1E8]/60 mt-10">Loading...</div> : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          {items.map((w) => {
            const gallery = normalizeGallery(w.gallery);
            const previewImage = w.cover || gallery[0] || "";
            return <div key={w.slug} className="border border-[#C99A45]/20 p-4 group" data-testid={`wedding-${w.slug}`}>
              <div className="aspect-[4/3] bg-[#151515] overflow-hidden">
                {previewImage && (
                  <img
                    src={fileUrl(previewImage)}
                    alt={w.couple || "Wedding story"}
                    className="w-full h-full wedding-cover-image"
                    style={{
                      "--cover-position-desktop": w.coverPositionDesktop || "center center",
                      "--cover-position-mobile": w.coverPositionMobile || "center center",
                      "--cover-fit": w.coverFit || "cover",
                    }}
                  />
                )}
              </div>
              <div className="mt-4">
                <div className="eyebrow text-[10px] text-[#C99A45]/80">{w.type} · {w.location}</div>
                <h3 className="font-serif-display text-2xl mt-1">{w.couple}</h3>
                <div className="eyebrow text-[9px] text-[#F7F1E8]/50 mt-1">/{w.slug} · {gallery.length} photos</div>
                <div className="flex gap-2 mt-4">
                  <Link to={`/admin/weddings/${w.slug}/edit`} className="btn-outline-gold !py-2 !px-3 text-xs flex-1" data-testid={`edit-${w.slug}`}>
                    <Edit3 size={12} /> Edit
                  </Link>
                  <button onClick={() => del(w.slug)} className="px-3 py-2 border border-[#E52717]/50 text-[#E52717] text-xs hover:bg-[#E52717] hover:text-white transition" data-testid={`delete-${w.slug}`}>
                    <Trash2 size={12} />
                  </button>
                </div>
              </div>
            </div>;
          })}
        </div>
      )}
    </div>
  );
}
